import { useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { DISPLAY_LABEL_FALLBACK } from '../../../constants/displayLabelFallback';
import { READ_ONLY } from 'customer-data-objects/property/AccessLevel';
import { getPrimaryDisplayLabelFromOptions } from '../../../helpers/propertiesHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const CUSTOMER_SUCCESS_PATH = '/customer-success';
const ALERTS_VIEW_PATH = '/actions/alerts/views/link';
const ALERT_LABEL = 'Alert';
const renderFallbackContainer = content => /*#__PURE__*/_jsx("div", {
  "data-selenium-test": "cs-alert-chicklet-title",
  "data-test-id": "cs-alert-chicklet-title",
  children: /*#__PURE__*/_jsx("span", {
    children: content
  })
});
const CustomerSuccessAlertChickletPrimaryDisplayLabel = ({
  toObjectId,
  primaryDisplayProperty,
  toObjectTypeId
}) => {
  const primaryDisplayLabel = getPrimaryDisplayLabelFromOptions(primaryDisplayProperty);
  const alertHref = useMemo(() => {
    if (!toObjectId) return null;
    const currentPortalId = PortalIdParser.get();
    const alertName = primaryDisplayLabel || ALERT_LABEL;
    const filterObject = [{
      operator: 'EQ',
      property: 'hs_object_id',
      value: toObjectId
    }];
    return `${CUSTOMER_SUCCESS_PATH}/${currentPortalId}${ALERTS_VIEW_PATH}?name=${encodeURIComponent(alertName)}&filters=${encodeURIComponent(JSON.stringify(filterObject))}`;
  }, [toObjectId, primaryDisplayLabel]);
  if (!(primaryDisplayProperty !== null && primaryDisplayProperty !== void 0 && primaryDisplayProperty.definition) || !toObjectId) {
    return renderFallbackContainer(primaryDisplayLabel || DISPLAY_LABEL_FALLBACK);
  }
  const {
    definition,
    value
  } = primaryDisplayProperty;
  const label = /*#__PURE__*/_jsx(FormattedPropertyV2, {
    accessLevel: READ_ONLY,
    objectTypeId: toObjectTypeId,
    objectId: toObjectId.toString(),
    value: value,
    "data-selenium-test": `property-input-${definition.name}`,
    "data-test-id": `property-input-${definition.name}`
    // @ts-expect-error Known property issue as they have not updated the type definitions
    // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
    ,
    property: definition
  });
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": "cs-alert-chicklet-title",
    "data-test-id": "cs-alert-chicklet-title",
    children: alertHref ? /*#__PURE__*/_jsx(Link, {
      href: alertHref,
      external: true,
      children: label || DISPLAY_LABEL_FALLBACK
    }) : /*#__PURE__*/_jsx("span", {
      children: label || DISPLAY_LABEL_FALLBACK
    })
  });
};
export default CustomerSuccessAlertChickletPrimaryDisplayLabel;